import { defaultKeybindings, keybindingCommandIds } from '../defaultKeybindings';
import type { KeybindingCommandId, KeybindingScheme, PlatformChords } from '../keybindingTypes';

const defaults = Object.fromEntries(
  keybindingCommandIds.map((commandId) => [commandId, defaultKeybindings[commandId].defaultChords]),
) as Record<KeybindingCommandId, PlatformChords>;

export const jamScheme: KeybindingScheme = {
  id: 'jam',
  label: 'Jam SQL',
  defaults,
};
